import script from "./HrSettingCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSettingCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./HrSettingCheckbox.vue?vue&type=style&index=0&id=0ffaf108&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffaf108"]])

export default __exports__